export const headCell = [
  {
    id: 'Date',
    label: 'Date',
    width: '100px',
    minWidth: '100px',
    disableSort: true,
  },
  {
    id: 'Account',
    label: 'Account',
    width: '150px',
    minWidth: '150px',
    disableSort: true,
  },
  {
    id: 'VoucherType',
    label: 'Voucher Type',
    width: '130px',
    minWidth: '130px',
    disableSort: true,
  },
  {
    id: 'VoucherNumber',
    label: 'Voucher Number',
    width: '130px',
    minWidth: '130px',
    disableSort: true,
  },

  {
    id: 'debit',
    label: 'Debit (₹)',
    width: '100px',
    minWidth: '100px',
    disableSort: true,
    numeric: true,
  },
  {
    id: 'credit',
    label: 'Credit (₹)',
    width: '100px',
    minWidth: '100px',
    disableSort: true,
    numeric: true,
  },
  {
    id: 'Balance',
    label: 'Balance (₹)',
    width: '100px',
    minWidth: '100px',
    disableSort: true,
    numeric: true,
  },
  {
    id: 'setOff',
    label: 'Set-Off',
    width: '130px',
    minWidth: '130px',
    disableSort: true,
    align: 'center',
  },
  {
    id: 'PendingSetoff',
    label: 'Pending To Set-Off (₹)',
    width: '110px',
    minWidth: '110px',
    disableSort: true,
    numeric: true,
  },
  {
    id: 'SetoffRemarks',
    label: 'Setoff Remarks',
    width: '200px',
    minWidth: '200px',
    disableSort: true,
  },
    {
    id: 'Narrations',
    label: 'Narration',
    width: '200px',
    minWidth: '200px',
    disableSort: true,
  },
  
];

// Helper function to get filtered headCell based on flag
export const getFilteredHeadCell = (showLinkedInvoiceVsReceipt) => {
  if (!showLinkedInvoiceVsReceipt) {
    return headCell.filter(cell => cell.id !== 'setOff' && cell.id !== 'PendingSetoff' && cell.id !== 'SetoffRemarks');
  }
  return headCell;
};
